<template>
  <div>
    <!-- قسم البحث والفلترة -->
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">جداول المهام</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <!-- بحث بالاسم -->
              <div
                class="md-layout-item md-size-30 md-small-size-100 ml-15 mtb-25"
              >
                <md-field>
                  <label>اسم جدول المهام</label>
                  <md-input v-model="taskScheduleName"></md-input>
                </md-field>
              </div>

              <!-- فلترة بالموظف -->
              <div
                class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
              >
                <model-list-select
                  class="input-must-rtl"
                  :list="employees"
                  v-model="employeeId"
                  option-value="key"
                  option-text="value"
                  placeholder="الموظف"
                >
                </model-list-select>
              </div>

              <!-- تاريخ من -->
              <div
                class="md-layout-item md-size-15 md-small-size-100 ml-15 mt-25"
              >
                <md-datepicker v-model="fromDate" :md-open-on-focus="false">
                  <label class="mr-28">تاريخ من</label>
                </md-datepicker>
              </div>

              <!-- تاريخ إلى -->
              <div
                class="md-layout-item md-size-15 md-small-size-100 ml-15 mt-25"
              >
                <md-datepicker v-model="toDate" :md-open-on-focus="false">
                  <label class="mr-28">تاريخ إلى</label>
                </md-datepicker>
              </div>
            </div>

            <!-- أزرار البحث -->
            <div class="md-layout">
              <div
                class="md-layout-item md-size-100 mt-25 mtb-25 center-content"
              >
                <md-button @click="filterData" class="md-info btn_nanosoft">
                  بحث
                </md-button>

                <md-button @click="goToCreate" class="md-success btn_nanosoft">
                  جديد
                </md-button>
                <md-button
                  @click="clearFilters"
                  class="md-secondary btn_nanosoft"
                >
                  إفراغ الحقول
                </md-button>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <!-- قسم الجدول -->
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-content>
            <!-- عدد النتائج لكل صفحة -->
            <div class="md-layout flex-content-left">
              <div class="md-layout-item md-size-15">
                <md-table>
                  <md-table-toolbar>
                    <md-field>
                      <label for="pages">عدد النتائج</label>
                      <md-select v-model="pagination.perPage" name="pages">
                        <md-option
                          v-for="item in pagination.perPageOptions"
                          :key="item"
                          :label="item"
                          :value="item"
                          >{{ item }}</md-option
                        >
                      </md-select>
                    </md-field>
                  </md-table-toolbar>
                </md-table>
              </div>
            </div>

            <!-- الجدول -->
            <md-table
              :value="filteredTableData"
              class="paginated-table table-striped table-hover"
              v-if="filteredTableData.length > 0"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="اسم جدول المهام">
                  {{ item.taskScheduleName }}
                </md-table-cell>
                <md-table-cell md-label="الموظف">
                  {{ item.employeeName || "-" }}
                </md-table-cell>
                <md-table-cell md-label="تاريخ من">
                  {{ formatDate(item.fromDate) }}
                </md-table-cell>
                <md-table-cell md-label="تاريخ إلى">
                  {{ formatDate(item.toDate) }}
                </md-table-cell>

                <!-- <md-table-cell md-label="الحالة">
                  {{ item.isConfirmed ? "معتمد" : "غير معتمد" }}
                </md-table-cell> -->

                <md-table-cell md-label>
                  <md-button
                    class="md-just-icon md-warning md-simple table-button-spacing"
                    @click.native="handleView(item)"
                    title="عرض"
                  >
                    <md-icon>dvr</md-icon>
                  </md-button>
                  <md-button
                    class="md-just-icon md-danger md-simple table-button-spacing"
                    @click.native="handleDelete(item)"
                    title="حذف"
                  >
                    <md-icon>close</md-icon>
                  </md-button>
                  <md-button
                    class="md-just-icon md-info md-simple table-button-spacing"
                    @click.native="openCloneDialog(item)"
                    title="نسخ"
                  >
                    <md-icon>file_copy</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table>

            <!-- رسالة عدم وجود بيانات -->
            <div class="md-layout" v-else>
              <div class="md-layout-item md-size-100 text-center">
                <p class="no-data-message">لا توجد بيانات</p>
              </div>
            </div>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            ></pagination>
          </md-card-actions>
        </md-card>
      </div>
    </div>
    <!-- مودل نسخ جدول المهام -->
    <md-dialog :md-active.sync="showCloneDialog" class="clone-dialog">
      <md-dialog-title>نسخ جدول المهام</md-dialog-title>
      <md-dialog-content>
        <div class="md-layout">
          <!-- تاريخ من -->
          <div class="md-layout-item  ml-15 mt-25">
            <md-datepicker v-model="cloneFrom" :md-open-on-focus="false">
              <label class="mr-28">تاريخ من</label>
            </md-datepicker>
          </div>

          <!-- تاريخ إلى -->
          <div class="md-layout-item  ml-15 mt-25">
            <md-datepicker v-model="cloneTo" :md-open-on-focus="false">
              <label class="mr-28">تاريخ إلى</label>
            </md-datepicker>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button
          class="md-primary"
          style="margin-inline: 10px;"
          :disabled="cloneLoading"
          @click="cloneTaskSchedule"
        >
          {{ cloneLoading ? "جاري النسخ..." : "نسخ" }}
        </md-button>
        <md-button @click="showCloneDialog = false">إلغاء</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import { ModelListSelect } from "vue-search-select";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  components: {
    Pagination,
    ModelListSelect,
  },

  async created() {
    await this.init();
  },

  data() {
    return {
      filteredTableData: [],
      taskScheduleName: "",
      employeeId: null,
      fromDate: null,
      toDate: null,
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      isInitialized: false,
      showCloneDialog: false,
      cloneItemId: null,
      cloneFrom: null,
      cloneTo: null,
      cloneLoading: false,
    };
  },

  computed: {
    employees() {
      const employeesData = this.$store.getters["global/employeesData"];
      return employeesData ? employeesData.employees : [];
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
  },

  watch: {
    pagination: {
      handler() {
        if (this.isInitialized) {
          this.loadData();
        }
      },
      deep: true,
    },
  },

  methods: {
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },

    async init() {
      await this.loadData();
      this.isInitialized = true;
    },

    async loadData() {
      try {
        const params = {
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.perPage,
        };

        // إضافة الفلاتر إذا كانت موجودة
        if (this.taskScheduleName && this.taskScheduleName.trim() !== "") {
          params.taskScheduleName = this.taskScheduleName;
        }

        if (this.employeeId) {
          params.employeeId = this.employeeId;
        }

        if (this.fromDate) {
          params.fromDate = moment(this.fromDate).format("YYYY-MM-DD");
        }

        if (this.toDate) {
          params.toDate = moment(this.toDate).format("YYYY-MM-DD");
        }

        const { data } = await this.$axios.get(`/api/TaskSchedule/filter`, {
          params,
        });

        console.warn("data", data);

        this.filteredTableData = data.data.results || [];
        this.pagination.total = data.data.total || 0;
      } catch (error) {
        this.notifyVue("top", "center", "danger", "خطأ في تحميل البيانات");
      }
    },

    async filterData() {
      this.pagination.currentPage = 1;
      await this.loadData();
    },

    async clearFilters() {
      this.taskScheduleName = "";
      this.employeeId = null;
      this.fromDate = null;
      this.toDate = null;
      this.pagination.currentPage = 1;
      await this.loadData();
    },

    formatDate(dateString) {
      if (!dateString) return "-";
      return moment(dateString).format("YYYY-MM-DD");
    },

    goToCreate() {
      this.$router.push("/pages/tasks-schedule/new");
    },

    handleView(item) {
      this.$router.push(`/pages/tasks-schedule/${item.id}`);
    },

    openCloneDialog(item) {
      this.cloneItemId = item.id;
      this.cloneFrom = null;
      this.cloneTo = null;
      this.showCloneDialog = true;
    },

    async cloneTaskSchedule() {
      if (!this.cloneFrom || !this.cloneTo) {
        this.notifyVue(
          "top",
          "center",
          "warning",
          "يرجى إدخال تاريخ من وتاريخ إلى",
        );
        return;
      }
      this.cloneLoading = true;
      try {
        const schema = {
          id: this.cloneItemId,
          From: moment(this.cloneFrom).format("YYYY-MM-DD"),
          To: moment(this.cloneTo).format("YYYY-MM-DD"),
        };
        const { data } = await this.$axios.post(
          "/api/TaskSchedule/Clone",
          schema,
        );
        if (data.message) {
          this.notifyVue("top", "center", "success", data.message);
        }
        this.showCloneDialog = false;
        await this.loadData();
      } catch (error) {
        let errorMessage =
          error.response.data.message || "خطأ في نسخ جدول المهام";
        this.notifyVue("top", "center", "danger", errorMessage);
      } finally {
        this.cloneLoading = false;
      }
    },

    handleDelete(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            const { data } = await this.$axios.delete(
              `/api/TaskSchedule/${item.id}`,
            );
            if (data.message) {
              this.notifyVue("top", "center", "success", data.message);
              await this.loadData();
            }
          } catch (error) {
            this.notifyVue("top", "center", "danger", "خطأ في الحذف");
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
  padding: 40px 20px;
}

.mt-25 {
  margin-top: 25px;
}

.no-data-message {
  font-size: 16px;
  color: #999;
  padding: 40px;
  margin: 0;
}

.table-button-spacing {
  margin: 0 5px !important;
}

.center-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.flex-content-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.card-category {
  font-size: 14px;
  color: #666;
  margin: 0;
  padding: 10px 15px;
  font-weight: 500;
}

.clone-dialog {
  direction: rtl;
  ::v-deep .md-dialog-container {
    max-width: 600px;
    width: 90%;
  }
}
</style>
